import { render, staticRenderFns } from "./JourneyLayout.vue?vue&type=template&id=29b15080&scoped=true"
import script from "./JourneyLayout.vue?vue&type=script&lang=js"
export * from "./JourneyLayout.vue?vue&type=script&lang=js"
import style0 from "./JourneyLayout.vue?vue&type=style&index=0&id=29b15080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b15080",
  null
  
)

export default component.exports